import { useCallback, useEffect, useState } from "react";

const useOpenModal = () => {
  const [open, setOpen] = useState(false);
  const [offsetY, setOffsetY] = useState(0);
  const [isIframe, setIsIframe] = useState(false);

  useEffect(() => {
    setIsIframe(window.top !== window.self);
  }, []);

  const fnListener = useCallback((event: any) => {
    const isValidRoot =
      "https://reit-invest.ru" === event.origin ||
      "https://itreit.ru" === event.origin;

    if (isValidRoot) {
      const offsetY = event.data > 0 ? event.data : 0;
      setOffsetY(offsetY);
      setOpen(true);
    }
  }, []);

  const handleChangeModalIframe = (isOpen: boolean, offsetY?: number) => {
    if (isOpen === false) {
      window.removeEventListener("message", fnListener);
      setOpen(false);
    } else {
      window.addEventListener("message", fnListener);
      window.parent.postMessage("scrollTop", "https://reit-invest.ru");
      window.parent.postMessage("scrollTop", "https://itreit.ru");
    }
  };

  const handleChangeModalDefault = (isOpen: boolean) => {
    setOffsetY(document.documentElement.scrollTop);
    setOpen(isOpen);
  };

  return {
    open,
    offsetY,
    handleChangeModal: isIframe
      ? handleChangeModalIframe
      : handleChangeModalDefault,
  };
};

export default useOpenModal;
